import React, { useRef, useState } from 'react'
import { Popover } from 'antd'
import { EyeOutlined, RotateRightOutlined, RotateLeftOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'

import './fileView.scss';

function FileIndex(props){
  const {
		url,
	} = props;

  const [rotate, setRotate] = useState(0);
  const [scale, setScale] = useState(1);

  const imgWrap = useRef(null);

  let dragDrop = false;
  let apartX, apartY;

  // 查看原图
  const openImg = () => {
    window.open(url)
  }

  // 旋转图片
  const rotateImg = (direction) => {
    if(direction){
      setRotate(rotate + 90)
    }else{
      setRotate(rotate - 90)
    }
  }

  // 放大缩小
  const scaleImg = (ismagnify) => {
    if(ismagnify){
      setScale(scale + 0.1)
    }else if(scale > 0.2){
      setScale(scale - 0.1)
    }
  }

  // 拖拽
  const _mouseDown = (event) => {
      dragDrop = true;
      apartX = event.pageX - imgWrap.current.offsetLeft;// 鼠标在图片中与图片左上角的X轴的距离
      apartY = event.pageY - imgWrap.current.offsetTop;

      event.preventDefault();
      event.stopPropagation();
  }
  const _mouseUp = (event) => {
      dragDrop = false;
      event.preventDefault();
      event.stopPropagation();
  }
  const _mouseMove = (event) => {
      if (!dragDrop) {
          return;
      }
      imgWrap.current.style.left = (event.pageX - apartX) + 'px';
      imgWrap.current.style.top = (event.pageY - apartY) + 'px';

      event.preventDefault();
      event.stopPropagation();
  }

	return (
		<div className="view-file-content">
      <div className="view-img">
        <div className="view-img-operation">
          <Popover content={"查看原图"} placement="bottom"><EyeOutlined onClick={openImg}/></Popover>
          <Popover content={"顺时针旋转"} placement="bottom"><RotateRightOutlined onClick={()=>rotateImg(true)}/></Popover>
          <Popover content={"逆时针旋转"} placement="bottom"><RotateLeftOutlined onClick={()=>rotateImg(false)}/></Popover>
          <Popover content={"放大"} placement="bottom"><ZoomInOutlined onClick={()=>scaleImg(true)}/></Popover>
          <Popover content={"缩小"} placement="bottom"><ZoomOutOutlined onClick={()=>scaleImg(false)}/></Popover>
        </div>
        <div className="view-img-box">
          <p 
            style={rotate !== 0 ? {transform: `rotate(${rotate}deg)`} : {}} 
            onMouseUp={_mouseUp}
            onMouseDown={_mouseDown}
            onMouseMove={_mouseMove}
            ref={imgWrap}
          >
            <img style={scale !== 1 ? {transform: `scale(${scale})`} : {}} src={("/view2" + url.split("/view2")[1])} alt={url}/>
          </p>
        </div>
      </div>
    </div>
	)
}

export default FileIndex;
